import { render, staticRenderFns } from "./tablaInvo.vue?vue&type=template&id=3c783ef2&scoped=true"
import script from "./tablaInvo.vue?vue&type=script&lang=js"
export * from "./tablaInvo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c783ef2",
  null
  
)

export default component.exports